import { Dropdown } from '@analytical-alley/ui';
import { AiOutlineDelete } from 'react-icons/ai';
import { MdOutlineSaveAs, MdPreview } from 'react-icons/md';
import { SlOptionsVertical } from 'react-icons/sl';

interface Props {
    canRequestReview: boolean;
    canDelete: boolean;
    onDelete: () => void;
    onRequestReview: () => void;
    onSaveAs: () => void;
}

export const CampaignCardActions = ({
    canRequestReview,
    canDelete,
    onDelete,
    onSaveAs,
    onRequestReview,
}: Props) => {
    return (
        <div className="flex gap-2">
            <Dropdown label={<SlOptionsVertical />} placement="right">
                {canRequestReview && (
                    <Dropdown.Item icon={MdPreview} onClick={onRequestReview}>
                        Request Review
                    </Dropdown.Item>
                )}
                {canDelete && (
                    <Dropdown.Item icon={AiOutlineDelete} onClick={onDelete}>
                        Delete
                    </Dropdown.Item>
                )}
                <Dropdown.Item icon={MdOutlineSaveAs} onClick={onSaveAs}>
                    Save As
                </Dropdown.Item>
            </Dropdown>
        </div>
    );
};
